// lib
import React, { ReactEventHandler } from 'react';
import { styled } from '@nykaa/ui-components';

// components
import BaseButton from 'shared/components/Button';

const Button = styled(BaseButton)`
  color: ${({ theme }) => theme.colors.secondary};
  background: none;
  padding: 0;
  justify-content: flex-start;
  height: auto;
  margin-top: ${({ theme }) => theme.spacing.spacing40};
  ${({ theme }) => theme.typography.buttonMedium}

  &:not([disabled]):hover {
    color: ${({ theme }) => theme.colors.secondary};
    background: none;
  }

  :active {
    color: ${({ theme }) => theme.colors.salmon600};
    text-decoration: underline;
  }
`;

// constants
const TEXT = 'Know More';

function KnowMore({ onClick }: { onClick: ReactEventHandler }) {
  return <Button onClick={onClick}>{TEXT}</Button>;
}

export default KnowMore;
